import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _get from 'lodash.get';
import { getGeoLocationData } from 'reduxUtils/modules/geo';
import InViewObserver from 'components/InViewObserver';
import Weather from '../../components/Weather';
import { getWeatherData, fetchWeatherData } from './redux';
import { iconsMap } from './config';
import { getNestedValue } from '../../routes/newslisting/layouts/config/AqiConfig';
import utils from './WeatherUtil';
//import stringUtils from '../../utils/string';

class WithWeather extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      weatherData: null,
      cityPostalId: '',
      currentCityAqiValue: '',
      weatherWidget: true,
      isPrimeUser: false,
    };
  }
  async setWeatherData(geoData, forceCity) {
    let geodata = {};
    geodata = geoData;
    geodata.city = geoData.city;
    if (forceCity) {
      try {
        const data = await fetchWeatherData(
          geodata,
          this.props.isPrimeUser,
          forceCity,
        );
        let weatherData = null;
        let postalId = null;
        let aqiValue = null;
        if (geodata && geodata.latitude && geodata.longitude) {
          const newWeatherData =
            data &&
            Array.isArray(data) &&
            data?.length > 0 &&
            data[0] &&
            data[0].value &&
            data[0].value.data;
          weatherData = utils.filterData(newWeatherData);
          const newLocationWeatherData =
            data &&
            Array.isArray(data) &&
            data?.length > 1 &&
            data[1] &&
            data[1].value &&
            data[1].value.data;
          postalId = utils.filterLocation(newLocationWeatherData);
          if (
            data &&
            Array.isArray(data) &&
            data?.length > 1 &&
            data[1].status === 'fulfilled'
          ) {
            const currentCityAqiData =
              data &&
              Array.isArray(data) &&
              data?.length > 2 &&
              data[2] &&
              data[2].value &&
              data[2].value.data &&
              data[2].value.data.data &&
              data[2].value.data.data.componentMap &&
              Object.keys(data[2].value.data.data.componentMap).length > 0 &&
              data[2].value.data.data.componentMap['AQI-IN']?.sensorData &&
              getNestedValue(data[2].value.data.data, [
                'componentMap',
                'AQI-IN',
                'sensorData',
              ]);
            aqiValue = currentCityAqiData;
          }
        } else {
          weatherData = null;
          const newLocationWeatherData =
            data &&
            Array.isArray(data) &&
            data?.length > 0 &&
            data[0] &&
            data[0].value &&
            data[0].value.data;
          postalId = utils.filterLocation(newLocationWeatherData);
          if (
            data &&
            Array.isArray(data) &&
            data?.length > 0 &&
            data[1].status === 'fulfilled'
          ) {
            const currentCityAqiData =
              data &&
              Array.isArray(data) &&
              data?.length > 1 &&
              data[1] &&
              data[1].value &&
              data[1].value.data &&
              data[1].value.data.data &&
              data[1].value.data.data.componentMap &&
              Object.keys(data[1].value.data.data.componentMap).length > 0 &&
              data[1].value.data.data.componentMap['AQI-IN']?.sensorData &&
              getNestedValue(data[1].value.data.data, [
                'componentMap',
                'AQI-IN',
                'sensorData',
              ]);
            aqiValue = currentCityAqiData;
          }
          this.setState({
            ...this.state,
            weatherWidget: false,
          });
        }
        this.setState({
          weatherData,
          cityPostalId: postalId,
          currentCityAqiValue: aqiValue,
        });
      } catch (error) {
        this.setState({
          weatherWidget: false,
        });
      }
    } else {
      //fetch data & store in Redux for entire page
      if (this.state.weatherData !== null) {
        this.setState({ weatherData: null });
      }

      this.props.getWeatherData(geodata, this.props.isPrimeUser);
    }
  }

  setWeatherDataApi = () => {
    const weatherData = this.state.weatherData || this.props.weatherData;
    if (!weatherData && this.props.geoCityData) {
      this.setWeatherData(this.props.geoCityData);
    }
  };

  componentDidMount() {
    const { lazyload } = this.props;
    if (!lazyload) {
      this.setWeatherDataApi();
    }
  }

  componentDidUpdate(prevProps) {
    // const { forcedCity } = this.props;
    const { geoCityData, forceCity } = this.props;
    // const city = forcedCity || _get(geoCityData, 'city');
    const city = _get(geoCityData, 'city');
    // const prevCity =
    //   prevProps.forcedCity || _get(prevProps.geoCityData, 'city');
    const prevCity = _get(prevProps.geoCityData, 'city');
    const prevForceCity = _get(prevProps, 'forceCity');
    if (city && city !== prevCity && forceCity && forceCity !== city) {
      this.updateGeoAndWeatherData(forceCity);
    } else if (city && city !== prevCity) {
      this.setWeatherData(geoCityData);
    } else if (forceCity && forceCity !== prevForceCity && forceCity !== city) {
      this.updateGeoAndWeatherData(forceCity);
    }
  }

  async updateGeoAndWeatherData(city) {
    const data = await getGeoLocationData(city);
    if (data.data) {
      this.setWeatherData(data.data, true);
    } else {
      this.setState({
        ...this.state,
        weatherWidget: false,
      });
    }
  }

  renderComponent = () => {
    const weatherData = this.state.weatherData || this.props.weatherData;
    const geoData = this.props.geoCityData;
    if (!weatherData && geoData && !this.props.lazyload) {
      this.setWeatherData(geoData);
      return null;
    }
    return (
      <>
        {geoData && weatherData && this.state.weatherWidget ? (
          <Weather
            data={weatherData}
            cityname={this.props.forceCity || geoData.city}
            cityPostalId={this.state.cityPostalId || this.props.cityPostalId}
            cityAqiValue={
              this.props.forceCity
                ? this.state.currentCityAqiValue
                : this.props.currentCityAqiValue
            }
            iconsMap={iconsMap}
            isToggleRequired="NO"
            isWapView={this.props.isWapView}
            isWeatherInC={
              geoData &&
              geoData.countryCode &&
              geoData.countryCode.toLowerCase() === 'in'
                ? true
                : this.props.isWeatherInC
            }
            colorTheme={this.props.colorTheme}
            hideCityName={this.props.hideCityName}
            addExtraClass={this.props.addExtraClass}
            gaCategory={this.props.gaCategory}
            showWeather={this.props.showWeather}
            isPrimeUser={this.props.isPrimeUser}
            showAqi={this.props.showAqi}
            showAqiText={this.props.showAqiText}
          />
        ) : (
          ''
        )}
      </>
    );
  };

  render() {
    const { lazyload = false } = this.props;

    return (
      <>
        {lazyload ? (
          <InViewObserver
            inViewCallback={() => {
              this.setWeatherDataApi();
            }}
            viewMargin="300px 0px 300px 0px"
          >
            {this.renderComponent()}
          </InViewObserver>
        ) : (
          this.renderComponent()
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  isPrimeUser: state.isPrime,
  weatherData: state.weather.weatherData,
  cityPostalId: state?.weather?.cityPostalId,
  currentCityAqiValue: state?.weather?.currentCityAqiValue,
  //geo: state.geo,
  geoCityData: state.geo.cityData,
  // geoStateData: state.geo.stateData,
});

const mapDispatchToProps = dispatch => ({
  getWeatherData: (params, isPrimeUser) => {
    dispatch(getWeatherData(params, isPrimeUser));
  },
});

WithWeather.propTypes = {
  getWeatherData: PropTypes.func.isRequired,
  weatherData: PropTypes.shape({}),
  geoCityData: PropTypes.shape({
    city: PropTypes.string,
  }),
  isWapView: PropTypes.bool,
  isWeatherInC: PropTypes.bool,
  colorTheme: PropTypes.string,
  hideCityName: PropTypes.bool,
  addExtraClass: PropTypes.string,
  lazyload: PropTypes.bool,
  isPrimeUser: PropTypes.bool,

  // geo: PropTypes.shape({
  //   cities: PropTypes.shape({}),
  //   currentCity: PropTypes.string,
  // }),
};

WithWeather.defaultProps = {
  weatherData: null,
  // geo: undefined,
  geoCityData: undefined,
  // geoStateData: undefined,
  isWapView: false,
  isWeatherInC: true,
  colorTheme: '',
  hideCityName: false,
  addExtraClass: '',
  lazyload: false,
  isPrimeUser: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(WithWeather);
